import qrService from "@/services/qr.service"
import { storeToRefs } from "pinia"
import { useQrsTableStore } from "@/stores/qrs"
import useAccountChecker from "@/composables/accountChecker"
import { QR_CONTENT, QR_SETTINGS, QR_STATUS, QR_TYPES } from "@/interfaces/qr"
import IncrementActiveQrsTotal from "../Account/IncrementActiveQrsTotal"
import { useUserAccountsStore } from "@/stores/userAccounts.js"

class CreateQrHandler {
  static render(router, query) {
    const { showLimitReachedModal } = storeToRefs(useQrsTableStore())
    if (useAccountChecker().isLimitReached("qr")) {
      return (showLimitReachedModal.value = true)
    }

    router.push({ name: "qr-builder-create", query })
  }

  static async apply({ gtin, project }) {
    const userAccountStore = useUserAccountsStore()
    const currentWorkspaceUserAccountIri = userAccountStore.currentWorkspaceAccountIri
    const payload = {
      pathName: gtin,
      account: currentWorkspaceUserAccountIri,
      status: QR_STATUS.DRAFT,
      settings: [
        {
          id: QR_SETTINGS.QR_TYPE,
          value: QR_TYPES.QR_CODE,
          enabled: true
        },
        {
          id: QR_SETTINGS.QR_CONTENT,
          value: QR_CONTENT.NONE,
          enabled: true
        },
        {
          id: QR_SETTINGS.SHOW_GTIN,
          value: true,
          enabled: true
        }
      ]
    }

    if (project) payload.project = `/api/projects/${project}`

    const qrCreated = await qrService.create({ payload })
    IncrementActiveQrsTotal.apply()

    return qrCreated
  }
}

export default CreateQrHandler
